module.exports = __webpack_public_path__ + "assets/img/service-QRcord-bz.b682cb47.jpg";